import React from 'react';
import { Routes } from 'react-router-dom';

import ProtectedRoute from '../../components/helpers/ProtectedRoute';
import Calendar from './Calendar';

export default () => (
	<Routes>
		<ProtectedRoute exact path={`/calendar`} component={Calendar} />
	</Routes>
);
